import React from 'react';
import {Card} from "../../components/Card";
import {createInternationalizationPrefixer} from "../i18n/i18n";
import {useFetchAllObjs} from "../hooks/PlatformTypeScriptHooks";

const t = createInternationalizationPrefixer("DeletedAccountsPage");

interface DeletedAccountRecord {
    id: string
    deletionInstantMillis: number
    maskedEmail: string
    deletedBySelf: boolean
    deletedByAdminName: string | null
}

function formatDeletionInstant(record: DeletedAccountRecord): string {
    if (!record.deletionInstantMillis) {
        return t("N/A");
    }
    return new Date(record.deletionInstantMillis).toLocaleString("pl");
}

function formatDeletedBy(record: DeletedAccountRecord): string {
    if (record.deletedBySelf) {
        return t("Samodzielnie");
    }
    return record.deletedByAdminName || t("N/A");
}

function DeletedAccountRow(props: { record: DeletedAccountRecord }) {
    const record = props.record;
    return <tr>
        <td>{formatDeletionInstant(record)}</td>
        <td>{record.maskedEmail || t("N/A")}</td>
        <td>{formatDeletedBy(record)}</td>
    </tr>;
}

function DeletedAccountsTable(props: { records: DeletedAccountRecord[] }) {
    const rows = props.records.map((record, index) => <DeletedAccountRow key={index} record={record}/>);
    return <table className="table table-striped">
        <thead>
        <tr>
            <th>{t("Data usunięcia")}</th>
            <th>{t("E-mail (zamaskowany)")}</th>
            <th>{t("Usunięte przez")}</th>
        </tr>
        </thead>
        <tbody>{rows}</tbody>
    </table>;
}

export default function DeletedAccountsPage() {

    const records = useFetchAllObjs<DeletedAccountRecord[]>("/api/deleted-accounts/recent");

    const loadingIndicator = <div className="text-center mt-4">...</div>;
    const emptyIndicator = <div className="text-center mt-4 h4 text-muted">{t("Brak usuniętych kont")}</div>;

    let content;
    if (records === null) {
        content = loadingIndicator;
    } else if (records.length === 0) {
        content = emptyIndicator;
    } else {
        content = <DeletedAccountsTable records={records}/>;
    }

    return <Card header={t("Usunięte konta")} subHeader={t("Ostatnie 50 usuniętych kont")} additionalClassNames="mt-4">
        {content}
    </Card>;
}
